import React from 'react';
import styles from './InputNew.module.scss';

const InputNew = ({
  placeholder,
  type = "text",
  name,
  value,
  onChange,
  onBlur,
  className = "",
  style = {},
  handleKey,
  ...props
}) => {
  return (
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={handleKey || undefined}
      placeholder={placeholder}
      className={`${styles.input} ${className}`}
      style={style}
      {...props}
    />
  );
};

export default InputNew;
